<!-- Mold Yönü Seçimi -->
<div class="ui horizontal divider header"
     style="margin-top: 0.1rem;margin-bottom:0.5rem;color: white;text-transform: unset;font-size:0.8rem;">
    Mold Yönü:
</div>

<!-- Yüzey Seçim Durumu -->
<div *ngIf="yonSecimAktif"
     style="margin-bottom: 0.5rem;padding: 0.5rem;background: #fff9c4;border-radius: 4px;font-size: 0.75rem;color: #333;">
    <strong>💡:</strong> Yüzeye tıkla
</div>

<!-- Seçili Yön Bilgisi -->
<div *ngIf="!yonSecimAktif && secilenFaceNormal"
     style="margin-bottom: 0.5rem;padding: 0.5rem;background: #c8e6c9;border-radius: 4px;font-size: 0.7rem;color: #333;">
    <div><strong>✓ Yüzey:</strong> ({{ secilenFaceNormal.x.toFixed(4) }}, {{ secilenFaceNormal.y.toFixed(4) }}, {{
        secilenFaceNormal.z.toFixed(4) }})</div>
    <button (click)="resetYuzeySecimi()"
            class="ui mini button"
            style="width:100%;margin-top:3px;padding:4px 8px;font-size:11px;">
        Seçimi Sıfırla
    </button>
</div>

<!-- Eksen Butonları ve Yön Seç -->
<div style="display: flex;justify-content: space-between;margin-bottom: 0.5rem;gap: 2px;">
    <button class="ui mini button"
            [class.primary]="moldDirection.x > 0.5 && !secilenFaceNormal"
            (click)="moldYonunuGuncelle('x')"
            [disabled]="yonSecimAktif"
            style="flex:1;padding:0.4rem;">
        <i class="arrows alternate horizontal icon"></i>
    </button>
    <button class="ui mini button"
            [class.primary]="moldDirection.y > 0.5 && !secilenFaceNormal"
            (click)="moldYonunuGuncelle('y')"
            [disabled]="yonSecimAktif"
            style="flex:1;padding:0.4rem;">
        <i class="arrows alternate vertical icon"></i>
    </button>
    <button class="ui mini button"
            [class.primary]="moldDirection.z > 0.5 && !secilenFaceNormal"
            (click)="moldYonunuGuncelle('z')"
            [disabled]="yonSecimAktif"
            style="flex:1;padding:0.4rem;">
        <i class="long arrow alternate up icon"></i>
    </button>
    <button class="ui mini button"
            [class.teal]="yonSecimAktif"
            (click)="yonSec()"
            [disabled]="yonSecimAktif"
            style="flex:2;padding:0.4rem;">
        <i class="hand pointer icon"></i> Yön Seç
    </button>
</div>

<!-- Yönü Tersine Çevir Butonu -->
<div style="margin-bottom: 0.5rem;">
    <button class="ui mini orange button"
            (click)="yonuTersineCevir()"
            [disabled]="yonSecimAktif"
            style="width:100%;padding:0.4rem;">
        <i class="exchange icon"></i> Yönü Tersine Çevir
    </button>
</div>

<!-- CNC Undercut Tespiti -->
<!-- <div class="ui horizontal divider header"
     style="margin-top: 0.5rem;margin-bottom:0.5rem;color: white;text-transform: unset;font-size:0.8rem;">
    CNC Undercut Tespiti:
</div> -->
<div
     style="margin-bottom: 0.5rem;padding: 0.3rem;background: rgba(244, 67, 54, 0.1);border-radius: 4px;border:1px solid rgba(244, 67, 54, 0.3);">
    <!-- Aktif/Pasif Toggle -->
    <!-- <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:0.5rem;">
        <label style="font-size:0.7rem;color:#aaa;">Undercut Tespiti:</label>
        <div class="ui toggle checkbox" style="transform:scale(0.8);">
            <input type="checkbox"
                   [ngModel]="undercutTespitiAktif"
                   (change)="undercutTespitiToggle()">
            <label style="color:white;font-size:0.65rem;">
                {{ undercutTespitiAktif ? 'Aktif' : 'Pasif' }}
            </label>
        </div>
    </div> -->

    <!-- Açıklama -->
    <!-- <div style="font-size:0.8rem;color:#f8aba9;padding:0.2rem;margin-bottom:0.5rem;">
        <i class="info circle icon"></i> CNC'de mold yönünden ulaşılamayan (ters kalan) tüm alanlar işaretlenir
    </div> -->

    <!-- Ana Ayarlar -->
    <div style="background: rgba(0,0,0,0.2);padding: 0.3rem;border-radius: 4px;margin-bottom:0.3rem;">
        <!-- Renkler - Yan Yana -->
        <div style="display:flex;gap:4px;margin-bottom:0.3rem;">
            <div style="display: flex;flex-direction: column;">
                <!-- Undercut Rengi -->
                <div>
                    <label style="font-size:0.6rem;color:#fff;display:block;margin-bottom:2px;">Undercut:</label>
                    <input type="color"
                       [value]="rgbToHex(undercutColorR, undercutColorG, undercutColorB)"
                       (input)="hexToRgb($event.target.value, 'undercut')"
                       style="width:100%;height:24px;cursor:pointer;border:1px solid #666;border-radius:3px;">
                </div>

                <!-- Normal Yüzey Rengi -->
                <div>
                    <label style="font-size:0.6rem;color:#fff;display:block;margin-bottom:2px;">Normal:</label>
                    <input type="color"
                       [value]="rgbToHex(normalColorR, normalColorG, normalColorB)"
                       (input)="hexToRgb($event.target.value, 'normal')"
                       style="width:100%;height:24px;cursor:pointer;border:1px solid #666;border-radius:3px;">
                </div>
            </div>
            <!-- Undercut Parlaklık -->
            <div style="display: flex;flex-direction: column;">
                <div style="flex:1;max-width: 130px;">
                    <label style="font-size:0.6rem;color:#fff;">Undercut Parlaklık:
                        {{undercutBrightness.toFixed(2)}}</label>
                    <input type="range" [(ngModel)]="undercutBrightness" (input)="shaderParametreleriniGuncelle()" min="0" max="1" step="0.01" style="width:100%;">
                </div>

                <!-- Depth Threshold -->
                <div style="flex:1; max-width: 130px;">
                    <label style="font-size:0.6rem;color:#fff;">Depth Hassasiyet: {{depthThreshold.toFixed(5)}}</label>
                    <input type="range" [(ngModel)]="depthThreshold" (input)="shaderParametreleriniGuncelle()" min="0.0001" max="0.01" step="0.0001" style="width:100%;">
                </div>
            </div>
        </div>


    </div>
</div>

<!-- Kontrol Butonları -->
<!-- <div class="ui horizontal divider header"
     style="margin-top: 0.5rem;margin-bottom:0.5rem;color: white;text-transform: unset;font-size:0.8rem;">
    Kontrol:
</div> -->
<div style="display: flex;justify-content: end;">
    <span style="flex:1"></span>
    @if (!analizAktif){
    <button class="ui icon mini green button "
            (click)="analiziBaslat()">
        <i class="play icon"></i>
        <!-- Başlat -->
    </button>
    }
    @if(analizAktif){
    <button class="ui icon mini red button"
            (click)="analiziDurdur()"
            style="margin-left:5px;">
        <i class="stop icon"></i>
        <!-- Durdur -->
    </button>
    }
</div>

@if (false){
<!-- Durum -->
<div style="margin-top: 0.5rem;text-align: center;">
    <span style="font-size: 0.8rem;"
          [class.text-success]="analizAktif"
          [class.text-warning]="!analizAktif">
        <i [class]="analizAktif ? 'check circle icon' : 'pause circle icon'"></i>
        {{ analizAktif ? 'Analiz Aktif' : 'Analiz Pasif' }}
    </span>
</div>

<!-- Gelişmiş Shader Ayarları -->

<div class="ui horizontal divider header"
     style="margin-top: 0.5rem;margin-bottom:0.5rem;color: white;text-transform: unset;font-size:0.8rem;cursor:pointer;"
     (click)="gelismisAyarlarAcik = !gelismisAyarlarAcik">
    <i [class]="gelismisAyarlarAcik ? 'angle down icon' : 'angle right icon'"></i>
    Gelişmiş Shader Ayarları
</div>

<div *ngIf="gelismisAyarlarAcik"
     style="margin-bottom: 0.5rem;">

    <!-- Işık Yoğunlukları -->
    <div class="ui horizontal divider header"
         style="margin:0.3rem 0;color:white;font-size:0.7rem;">Işık Yoğunlukları</div>
    <div style="background: rgba(0,0,0,0.2);padding: 0.3rem;border-radius: 4px;margin-bottom:0.3rem;">
        <div style="margin-bottom:0.2rem;">
            <label style="font-size:0.6rem;color:#aaa;">Key Light: {{keyLightIntensity.toFixed(2)}}</label>
            <input type="range" [(ngModel)]="keyLightIntensity" (input)="shaderParametreleriniGuncelle()" min="0" max="1" step="0.01" style="width:100%;">
        </div>
        <div style="margin-bottom:0.2rem;">
            <label style="font-size:0.6rem;color:#aaa;">Fill Light: {{fillLightIntensity.toFixed(2)}}</label>
            <input type="range" [(ngModel)]="fillLightIntensity" (input)="shaderParametreleriniGuncelle()" min="0" max="1" step="0.01" style="width:100%;">
        </div>
        <div style="margin-bottom:0.2rem;">
            <label style="font-size:0.6rem;color:#aaa;">Rim Light: {{rimLightIntensity.toFixed(2)}}</label>
            <input type="range" [(ngModel)]="rimLightIntensity" (input)="shaderParametreleriniGuncelle()" min="0" max="1" step="0.01" style="width:100%;">
        </div>
        <div>
            <label style="font-size:0.6rem;color:#aaa;">Ambient: {{ambientLight.toFixed(2)}}</label>
            <input type="range" [(ngModel)]="ambientLight" (input)="shaderParametreleriniGuncelle()" min="0" max="1" step="0.01" style="width:100%;">
        </div>
    </div>

    <!-- Işık Pozisyonları - Key Light -->
    <div class="ui horizontal divider header"
         style="margin:0.3rem 0;color:white;font-size:0.7rem;">Key Light Pozisyon</div>
    <div style="background: rgba(0,0,0,0.2);padding: 0.3rem;border-radius: 4px;margin-bottom:0.3rem;">
        <div style="display:flex;gap:4px;margin-bottom:0.2rem;">
            <div style="flex:1;">
                <label style="font-size:0.6rem;color:#aaa;">X: {{keyLightX.toFixed(2)}}</label>
                <input type="range" [(ngModel)]="keyLightX" (input)="shaderParametreleriniGuncelle()" min="-2" max="2" step="0.1" style="width:100%;">
            </div>
            <div style="flex:1;">
                <label style="font-size:0.6rem;color:#aaa;">Y: {{keyLightY.toFixed(2)}}</label>
                <input type="range" [(ngModel)]="keyLightY" (input)="shaderParametreleriniGuncelle()" min="-2" max="2" step="0.1" style="width:100%;">
            </div>
            <div style="flex:1;">
                <label style="font-size:0.6rem;color:#aaa;">Z: {{keyLightZ.toFixed(2)}}</label>
                <input type="range" [(ngModel)]="keyLightZ" (input)="shaderParametreleriniGuncelle()" min="-2" max="2" step="0.1" style="width:100%;">
            </div>
        </div>
    </div>

    <!-- Işık Pozisyonları - Fill Light -->
    <div class="ui horizontal divider header"
         style="margin:0.3rem 0;color:white;font-size:0.7rem;">Fill Light Pozisyon</div>
    <div style="background: rgba(0,0,0,0.2);padding: 0.3rem;border-radius: 4px;margin-bottom:0.3rem;">
        <div style="display:flex;gap:4px;margin-bottom:0.2rem;">
            <div style="flex:1;">
                <label style="font-size:0.6rem;color:#aaa;">X: {{fillLightX.toFixed(2)}}</label>
                <input type="range" [(ngModel)]="fillLightX" (input)="shaderParametreleriniGuncelle()" min="-2" max="2" step="0.1" style="width:100%;">
            </div>
            <div style="flex:1;">
                <label style="font-size:0.6rem;color:#aaa;">Y: {{fillLightY.toFixed(2)}}</label>
                <input type="range" [(ngModel)]="fillLightY" (input)="shaderParametreleriniGuncelle()" min="-2" max="2" step="0.1" style="width:100%;">
            </div>
            <div style="flex:1;">
                <label style="font-size:0.6rem;color:#aaa;">Z: {{fillLightZ.toFixed(2)}}</label>
                <input type="range" [(ngModel)]="fillLightZ" (input)="shaderParametreleriniGuncelle()" min="-2" max="2" step="0.1" style="width:100%;">
            </div>
        </div>
    </div>

    <!-- Işık Pozisyonları - Rim Light -->
    <div class="ui horizontal divider header"
         style="margin:0.3rem 0;color:white;font-size:0.7rem;">Rim Light Pozisyon</div>
    <div style="background: rgba(0,0,0,0.2);padding: 0.3rem;border-radius: 4px;margin-bottom:0.3rem;">
        <div style="display:flex;gap:4px;margin-bottom:0.2rem;">
            <div style="flex:1;">
                <label style="font-size:0.6rem;color:#aaa;">X: {{rimLightX.toFixed(2)}}</label>
                <input type="range" [(ngModel)]="rimLightX" (input)="shaderParametreleriniGuncelle()" min="-2" max="2" step="0.1" style="width:100%;">
            </div>
            <div style="flex:1;">
                <label style="font-size:0.6rem;color:#aaa;">Y: {{rimLightY.toFixed(2)}}</label>
                <input type="range" [(ngModel)]="rimLightY" (input)="shaderParametreleriniGuncelle()" min="-2" max="2" step="0.1" style="width:100%;">
            </div>
            <div style="flex:1;">
                <label style="font-size:0.6rem;color:#aaa;">Z: {{rimLightZ.toFixed(2)}}</label>
                <input type="range" [(ngModel)]="rimLightZ" (input)="shaderParametreleriniGuncelle()" min="-2" max="2" step="0.1" style="width:100%;">
            </div>
        </div>
    </div>

    <!-- AO & Edge -->
    <div class="ui horizontal divider header"
         style="margin:0.3rem 0;color:white;font-size:0.7rem;">Ambient Occlusion & Edge</div>
    <div style="background: rgba(0,0,0,0.2);padding: 0.3rem;border-radius: 4px;margin-bottom:0.3rem;">
        <div style="margin-bottom:0.2rem;">
            <label style="font-size:0.6rem;color:#aaa;">AO Yoğunluk: {{aoIntensity.toFixed(2)}}</label>
            <input type="range" [(ngModel)]="aoIntensity" (input)="shaderParametreleriniGuncelle()" min="0" max="10" step="0.1" style="width:100%;">
        </div>
        <div style="margin-bottom:0.2rem;">
            <label style="font-size:0.6rem;color:#aaa;">AO Max: {{aoMax.toFixed(2)}}</label>
            <input type="range" [(ngModel)]="aoMax" (input)="shaderParametreleriniGuncelle()" min="0" max="1" step="0.01" style="width:100%;">
        </div>
        <div style="margin-bottom:0.2rem;">
            <label style="font-size:0.6rem;color:#aaa;">Edge Yoğunluk: {{edgeIntensity.toFixed(2)}}</label>
            <input type="range" [(ngModel)]="edgeIntensity" (input)="shaderParametreleriniGuncelle()" min="0" max="10" step="0.1" style="width:100%;">
        </div>
        <div>
            <label style="font-size:0.6rem;color:#aaa;">Edge Karartma: {{edgeDarkness.toFixed(2)}}</label>
            <input type="range" [(ngModel)]="edgeDarkness" (input)="shaderParametreleriniGuncelle()" min="0" max="1" step="0.01" style="width:100%;">
        </div>
    </div>

    <!-- Varsayılan Değerler Butonu -->
    <button class="ui mini button fluid orange"
            (click)="varsayilanDegerleriYukle()"
            style="padding:0.4rem;font-size:0.7rem;">
        <i class="undo icon"></i> Varsayılan Değerlere Dön
    </button>
</div>
}